<template>
    <thead class="border-t">
        <slot />
    </thead>
</template>
